import script from "./ProductInformationsSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductInformationsSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductInformationsSkeleton.vue?vue&type=style&index=0&id=5fe77c5f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fe77c5f"]])

export default __exports__